import { render, staticRenderFns } from "./CopyrightTask.vue?vue&type=template&id=674c9510&scoped=true&"
import script from "./CopyrightTask.vue?vue&type=script&lang=js&"
export * from "./CopyrightTask.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightTask.vue?vue&type=style&index=0&id=674c9510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c9510",
  null
  
)

export default component.exports